import { Flame } from 'lucide-react'
import type { Discipline, OverplayedSong } from '@/hooks/useDashboardChannel'
import { formatPrecise } from '@/lib/format'
import { workoutNouns } from '@/lib/discipline'

interface OverplayedSongSpotlightProps {
  song: OverplayedSong
  discipline: Discipline
}

export function OverplayedSongSpotlight({ song, discipline }: OverplayedSongSpotlightProps) {
  const { plural } = workoutNouns(discipline)
  return (
    <div className="relative isolate flex items-center gap-5 overflow-hidden rounded-xl border border-border bg-card p-6">
      {song.album_image_url && (
        <>
          <img
            src={song.album_image_url}
            alt=""
            aria-hidden
            className="absolute inset-0 -z-20 size-full scale-125 object-cover opacity-40 blur-2xl"
          />
          <div className="absolute inset-0 -z-10 bg-gradient-to-r from-card via-card/80 to-card/40" />
        </>
      )}

      {song.album_image_url ? (
        <img
          src={song.album_image_url}
          alt=""
          className="size-20 shrink-0 rounded-lg object-cover shadow-lg ring-1 ring-white/10"
        />
      ) : (
        <div className="flex size-20 shrink-0 items-center justify-center rounded-lg bg-primary/10 text-primary">
          <Flame className="size-8" strokeWidth={2} />
        </div>
      )}

      <div className="flex min-w-0 flex-1 flex-col gap-0.5">
        <span className="flex items-center gap-1.5 text-xs font-medium uppercase tracking-wide text-muted-foreground">
          <Flame className="size-3.5 text-primary" />
          Most overplayed track
        </span>
        <span className="truncate text-2xl font-semibold tracking-tight">{song.title}</span>
        <span className="truncate text-sm text-muted-foreground">{song.artists.join(', ')}</span>
      </div>

      <div className="flex shrink-0 flex-col items-end">
        <span className="text-3xl font-semibold tabular-nums">{formatPrecise(song.ride_count)}</span>
        <span className="text-xs text-muted-foreground">{plural} and counting</span>
      </div>
    </div>
  )
}
